var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-direction-column flex-grow-1 d-flex align-center justify-center"},[_c('div',{staticClass:"vp-warning"},[_c('Logo',{attrs:{"icon":"","loading":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }